import React from 'react'
import LinearProgress from "@material-ui/core/LinearProgress"
import { withStyles } from "@material-ui/styles"

const BorderLinearProgress = withStyles(() => ({
    root: {
        height: '1em',
        borderRadius: `1em`,
        width: 250,
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
    },
    colorPrimary: {
        backgroundColor: 'rgba(255,255,255,0.2)',
        boxShadow: 'inset 0 1px 2px rgba(2,14,60,0.5)'

    },
    bar: {
        borderRadius: "1em 0 0 1em",
        background: "white"
    },
}))(LinearProgress);

const TerminalProgressBar = (props) => {

    return (
        <BorderLinearProgress variant="determinate" {...props} />
    );

}

export default TerminalProgressBar
